/* Work in progres!!! preparation for wtPopover component, currently only
supports 1 state (below element, arrow pointing up) */

<template>
  <transition name="wt2-fade">
    <div class="wt2-popover" v-if="visible" v-click-outside="clickOutside">
      <div class="-arrow -up"></div>
      <div class="-content">
        <slot></slot>
      </div>
      <div class="wt2-link -close" @click="hide(true)">{{ closeTxt }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    closeTxt: {
      type: String,
      default: 'Got It',
    },
    clickOutisdeCloses: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide(manualClose = false) {
      if (manualClose) {
        console.log('manual close');
        this.$emit('close', 'a');
      }
      this.visible = false;
    },
    clickOutside() {
      this.clickOutisdeCloses && this.visible && this.hide();
    },
  },
};
</script>

<style lang="scss">
.wt2-popover {
  position: absolute;
  background: #ffffff;
  z-index: 999999999;
  padding: 20px 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  border-left: 3px solid #06a9f4;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  margin-top: 15px;

  .-close {
    font-size: 14px;
    margin-top: 15px;
    float: right;
    cursor: pointer;
  }

  .-arrow {
    width: 0;
    height: 0;
    position: absolute;
    &.-up {
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid white;
      right: 65px;
      top: -10px;
    }
  }
}
</style>
